import { useContext, useEffect } from 'react';
import { AuthContext } from './AuthProvider';
import { ALMA_INSIGHTS_CALLBACK_URL } from '../../utilities/Links';

export function RegisterPage() {
  const { actions, loading } = useContext(AuthContext);

  useEffect(() => {
    const handleRegister = async () => {
      // This check makes sure that AlmaAccountCore instance is initialized and actions are available before continuing.
      if (!loading && actions) {
        /* An authenticated user cannot register again, so we should check if
        the user is already authenticated before redirecting them to Alma
        Business Account registration page. If the user is authenticated, we
        redirect them to the Sisältöpalvelut "Omat sisällöt" page. */
        const token = await actions.getAccessToken();
        if (token) {
          window.location.replace(ALMA_INSIGHTS_CALLBACK_URL);
          return;
        }

        actions.register(true);
      }
    };

    handleRegister();
  }, [actions, loading]);

  return null;
}
